/* eslint-disable no-unused-vars */
import { useInfiniteQuery, useQuery } from 'react-query';

import {
  getOngoingIDODetails,
  getOngoingNftDetails,
  getPastIDODetails,
  getPastNftDetails,
  getTokenDetail,
  getUpcommingIDODetails,
  getUpcommingNftDetails,
  getNFTDetail,
  getIDONFTDetails
} from '../services/api';

import { LIMIT } from './constants';

//idos
export const useFetchOngoingIdos = () => {
  return useInfiniteQuery(
    ['ongoingIDOs'],
    async ({ pageParam = 0 }) => {
      const res = await getOngoingIDODetails(LIMIT, pageParam);
      return res.data;
    },
    {
      getNextPageParam: (lastPage) => {
        return lastPage?.hasMore ? lastPage.offset + LIMIT : undefined;
      }
    }
  );
};

export const useFetchPastIdos = () => {
  return useInfiniteQuery(
    ['pastIDOs'],
    async ({ pageParam = 0 }) => {
      const res = await getPastIDODetails(LIMIT, pageParam);
      return res.data;
    },
    {
      getNextPageParam: (lastPage, pages) => {
        return lastPage?.hasMore ? lastPage.offset + LIMIT : undefined;
      }
    }
  );
};

export const useFetchUpcommingIdos = () => {
  return useInfiniteQuery(
    ['upcommingIDOs'],
    async ({ pageParam = 0 }) => {
      const res = await getUpcommingIDODetails(LIMIT, pageParam);
      return res.data;
    },
    {
      getNextPageParam: (lastPage, pages) => {
        return lastPage?.hasMore ? lastPage.offset + LIMIT : undefined;
      }
    }
  );
};

//nfts
export const useFetchOngoingNfts = () => {
  return useInfiniteQuery(
    ['ongoingNfts'],
    async ({ pageParam = 0 }) => {
      const res = await getOngoingNftDetails(LIMIT, pageParam);
      return res.data;
    },
    {
      getNextPageParam: (lastPage, pages) => {
        return lastPage?.hasMore ? lastPage.offset + LIMIT : undefined;
      }
    }
  );
};

export const useFetchPastNfts = () => {
  return useInfiniteQuery(
    ['pastNfts'],
    async ({ pageParam = 0 }) => {
      const res = await getPastNftDetails(LIMIT, pageParam);
      return res.data;
    },
    {
      getNextPageParam: (lastPage, pages) => {
        return lastPage?.hasMore ? lastPage.offset + LIMIT : undefined;
      }
    }
  );
};

export const useFetchUpcommingNfts = () => {
  return useInfiniteQuery(
    ['upcommingNfts'],
    async ({ pageParam = 0 }) => {
      const res = await getUpcommingNftDetails(LIMIT, pageParam);
      return res.data;
    },
    {
      getNextPageParam: (lastPage, pages) => {
        return lastPage?.hasMore ? lastPage.offset + LIMIT : undefined;
      }
    }
  );
};
//details

export const useFetchIDODetail = (tokenID) => {
  return useQuery(
    ['idoDetail', tokenID],
    async () => {
      const res = await getTokenDetail(tokenID);
      return res.data.items[0];
    },
    {
      enabled: tokenID ? true : false
    }
  );
};

export const useFetchNftDetail = (tokenID) => {
  return useQuery(
    ['nftDetail', tokenID],
    async () => {
      const res = await getNFTDetail(tokenID);
      return res.data.items[0];
    },
    {
      enabled: tokenID ? true : false
    }
  );
};

//search
export const useFetchAllData = () => {
  return useQuery(['allData'], async () => {
    const res = await getIDONFTDetails();
    return res.data.items;
  });
};
